export default __webpack_public_path__ + "static/media/home-startup-service-img-01.c457b767.jpg";